// extracted by mini-css-extract-plugin
module.exports = {"play_video":"play_video_play_video__2TUOx","title":"play_video_title__3mDTS","channel":"play_video_channel__OAiR5","info":"play_video_info__B6_mP"};